// extracted by mini-css-extract-plugin
module.exports = {"layout":"layout_layout__F9dvV","layout--mobile":"layout_layout--mobile__KrGNl","secondary-sidebar":"layout_secondary-sidebar__S1cGZ","section":"layout_section__Y7oVt"};